// core/util.js — small helpers shared by both apps. No React, no DOM at load time.

export const clamp = (v, a, b) => Math.min(b, Math.max(a, v))

export function randId() {
  return [...crypto.getRandomValues(new Uint8Array(8))].map((b) => b.toString(16).padStart(2, '0')).join('')
}

export function b64(u8) {
  let s = ''
  for (let i = 0; i < u8.length; i += 0x8000) s += String.fromCharCode.apply(null, u8.subarray(i, i + 0x8000))
  return btoa(s)
}
export function unb64(s) {
  const bin = atob(s)
  const u = new Uint8Array(bin.length)
  for (let i = 0; i < bin.length; i++) u[i] = bin.charCodeAt(i)
  return u
}

export const esc = (s) => String(s ?? '').replace(/[&<>"]/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]))

export const fmtTime = (sec) => {
  sec = Math.max(0, Math.round(sec || 0))
  return Math.floor(sec / 60) + ':' + String(sec % 60).padStart(2, '0')
}

export const vibrate = (ms = 12) => { try { navigator.vibrate && navigator.vibrate(ms) } catch (e) { /* not supported */ } }

/**
 * Chat apps and email wrap long text in invisible marks (bidi, zero-width,
 * non-breaking spaces). Strip everything that isn't printable ASCII before
 * parsing a pasted code or link.
 */
export const cleanPasted = (text) => String(text || '').replace(/[^\x21-\x7e]/g, '')

/** localStorage / sessionStorage that never throws (private mode, blocked storage). */
export function makeStore(prefix, kind = 'local') {
  const s = () => (kind === 'session' ? window.sessionStorage : window.localStorage)
  return {
    get(k, d) { try { const v = s().getItem(prefix + k); return v === null ? d : JSON.parse(v) } catch (e) { return d } },
    set(k, v) { try { if (v == null) s().removeItem(prefix + k); else s().setItem(prefix + k, JSON.stringify(v)) } catch (e) { /* storage off */ } },
  }
}

export function deviceLabel() {
  const ua = navigator.userAgent || ''
  const os = /iPad|Macintosh.*Mobile/.test(ua) || (/Macintosh/.test(ua) && navigator.maxTouchPoints > 1) ? 'iPad'
    : /iPhone/.test(ua) ? 'iPhone' : /CrOS/.test(ua) ? 'Chromebook' : /Android/.test(ua) ? (/Mobile/.test(ua) ? 'Android phone' : 'Android tablet')
      : /Windows/.test(ua) ? 'Windows' : /Macintosh/.test(ua) ? 'Mac' : /Silk|Kindle/.test(ua) ? 'Fire tablet' : 'Computer'
  const br = /Edg\//.test(ua) ? 'Edge' : /SamsungBrowser/.test(ua) ? 'Samsung Internet' : /Silk/.test(ua) ? 'Silk'
    : /Firefox|FxiOS/.test(ua) ? 'Firefox' : /Chrome|CriOS/.test(ua) ? 'Chrome' : /Safari/.test(ua) ? 'Safari' : 'browser'
  return os + ' · ' + br
}

/**
 * Full screen on or off, with the prefixed calls older Safari on iPad needs. iPhone Safari
 * can't make a page full screen at all: then onFail runs, so the screen can say what to do.
 */
export function toggleFullscreen(onFail) {
  const d = document, el = d.documentElement
  const fail = () => { if (onFail) onFail(/iPhone|iPod/.test(navigator.userAgent)) }
  try {
    if (d.fullscreenElement || d.webkitFullscreenElement) { const x = d.exitFullscreen || d.webkitExitFullscreen; if (x) { const p = x.call(d); if (p && p.catch) p.catch(() => {}) } return }
    const req = el.requestFullscreen || el.webkitRequestFullscreen
    if (!req) { fail(); return }
    const p = req.call(el)
    if (p && p.catch) p.catch(fail)
  } catch (e) { fail() }
}
